import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
const CustomBackend = function CustomBackend(manager, context, options) {
  if (!manager) {
    throw new Error('CustomBackend requires a manager');
  }

  const backend = Object.create(CustomBackend.prototype);
  backend.manager = manager;
  backend.context = context;
  backend.options = options || {};

  backend.html5Backend = HTML5Backend(manager, context, {});

  const touchBackendConfig = {
    enableMouseEvents: true,
    enableTouchEvents: true,
    delayTouchStart: 0,
    delayMouseStart: 0,
    ignoreContextMenu: true,
  };

  backend.touchBackend = TouchBackend(manager, context, touchBackendConfig);

  backend.sourceBackendMap = new Map();

  return backend;
};

CustomBackend.prototype.setup = function setup() {
  this.html5Backend.setup();
  this.touchBackend.setup();
};

CustomBackend.prototype.teardown = function teardown() {
  this.html5Backend.teardown();
  this.touchBackend.teardown();
};

CustomBackend.prototype.connectDragSource = function connectDragSource(sourceId, node, options) {
  const isTreeView = node && node.closest('[data-drag-backend="multibackend"]');

  if (isTreeView) {
    // For tree views, use both HTML5Backend and TouchBackend
    this.sourceBackendMap.set(sourceId, this.html5Backend);
    const html5Unsubscribe = this.html5Backend.connectDragSource(sourceId, node, options);
    const touchUnsubscribe = this.touchBackend.connectDragSource(sourceId, node, options);

    return () => {
      html5Unsubscribe();
      touchUnsubscribe();
    };
  }

  // For non-tree views, use only TouchBackend
  this.sourceBackendMap.set(sourceId, this.touchBackend);
  return this.touchBackend.connectDragSource(sourceId, node, options);
};

CustomBackend.prototype.connectDragPreview = function connectDragPreview(sourceId, node, options) {
  const backend = this.sourceBackendMap.get(sourceId) || this.touchBackend;
  return backend.connectDragPreview(sourceId, node, options);
};

CustomBackend.prototype.connectDropTarget = function connectDropTarget(targetId, node) {
  const touchUnsubscribe = this.touchBackend.connectDropTarget(targetId, node);
  const html5Unsubscribe = this.html5Backend.connectDropTarget(targetId, node);

  return () => {
    touchUnsubscribe();
    html5Unsubscribe();
  };
};

CustomBackend.prototype.profile = function profile() {
  return { CustomBackend: 1 };
};

export default CustomBackend;
